module.exports = __webpack_public_path__ + "static/media/logo-login-app.c7a53469.png";